import PropTypes from 'prop-types';

export const ContentActivityIcon = ({ className = '' }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 5H5L5 19H19V5ZM5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5Z"
      fill={className}
    />
    <path
      d="M17.0183 12.566L12.996 14.8804L8.97366 17.1949C8.43097 17.5141 8 17.2587 8 16.6362V7.36252C8 6.74002 8.43097 6.48464 8.97366 6.80387L12.996 9.1183L17.0183 11.4327C17.561 11.752 17.561 12.2468 17.0183 12.566Z"
      fill={className}
    />
  </svg>
);

ContentActivityIcon.propTypes = {
  className: PropTypes.string,
};
